import VerticalMenu from './vertical-menu'
export default VerticalMenu
